/**
 * The read-only notice, as a {@link useShowMutationError} override.
 *
 * A 403 on a project or membership change means the admin role went away mid-session: the control
 * that started the change was offered on the strength of `useIsAdmin()`, and the server has since
 * disagreed. The spec asks every such refusal to show the read-only notice rather than the generic
 * failure toast, so every project mutation spreads this same entry into its overrides.
 */
export const ADMIN_REQUIRED_OVERRIDE = {
  403: { message: 'Only administrators can change projects. Reload the page to see what you can do.' },
}
